"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var FieldClassNamePipe = /** @class */ (function () {
    function FieldClassNamePipe() {
    }
    FieldClassNamePipe.prototype.isCategoryField = function (fieldType) {
        return fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.PARENT
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.USER;
    };
    FieldClassNamePipe.prototype.transform = function (field) {
        if (this.isCategoryField(field.metaFieldType)) {
            return 'mat-option-text__green';
        }
        else {
            return 'mat-option-text__blue';
        }
    };
    FieldClassNamePipe = __decorate([
        core_1.Pipe({
            name: 'fieldClassName',
            pure: true
        })
    ], FieldClassNamePipe);
    return FieldClassNamePipe;
}());
exports.FieldClassNamePipe = FieldClassNamePipe;
//# sourceMappingURL=field-class-name.pipe.js.map